var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper countdown"},[_vm._l((_vm.from),function(n){return [_c('span',{ref:"number",refInFor:true,staticClass:"number",style:({ 'font-size': _vm.fontSize })},[_vm._v(_vm._s(_vm.from - ( n - 1 )))])]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e83b71d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Countdown.vue
// module id = null
// module chunks = 